"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteInteractionsStore = void 0;
var mobx_1 = require("mobx");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var QuoteInteractionsStore = (function () {
    function QuoteInteractionsStore() {
        this._quoteInteractions = {};
    }
    QuoteInteractionsStore.prototype.createOrUpdateQuoteInteraction = function (id, type, interaction, initialValue) {
        var existingInteraction = this._quoteInteractions[id];
        if (existingInteraction != undefined) {
            (0, tiny_invariant_1.default)(initialValue.selection.mode === "optional");
            if (initialValue.selection.selected === interaction.selected) {
                this._quoteInteractions[id] = undefined;
            }
            else {
                this._quoteInteractions[id] = __assign(__assign({}, existingInteraction), interaction);
            }
        }
        else {
            this._quoteInteractions[id] = __assign({ type: type }, interaction);
        }
    };
    QuoteInteractionsStore.prototype.getQuoteInteractionById = function (id) {
        return this._quoteInteractions[id];
    };
    QuoteInteractionsStore.prototype.serialiseInteractions = function () {
        return Object.fromEntries(Object.entries(this._quoteInteractions).filter(function (entry) { return entry[1] !== undefined; }));
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], QuoteInteractionsStore.prototype, "_quoteInteractions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, typeof (_a = typeof T !== "undefined" && T) === "function" ? _a : Object, typeof (_b = typeof Omit !== "undefined" && Omit) === "function" ? _b : Object, Object]),
        __metadata("design:returntype", void 0)
    ], QuoteInteractionsStore.prototype, "createOrUpdateQuoteInteraction", null);
    return QuoteInteractionsStore;
}());
exports.QuoteInteractionsStore = QuoteInteractionsStore;
